import { useMemo } from 'react';

export const useOrderProductShowPrice = (
  platform: General.Platform,
  promotionType?: Conversation.Trade.Product['promotionType'],
) => {
  return useMemo(
    () => ['shopee', 'tiktok', 'tiktok_us'].includes(platform) && promotionType !== 'bundle_deal',
    [promotionType, platform],
  );
};
